"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_FOOTER_RECALC_TRIGGER = void 0;
var feature_flipper_1 = require("@shared/constants/feature-flipper");
var environment_1 = require("@shared/types/environment");
var angular_1 = __importDefault(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var HEADER_FOOTER_RECALC_TRIGGER;
(function (HEADER_FOOTER_RECALC_TRIGGER) {
    HEADER_FOOTER_RECALC_TRIGGER["filters"] = "filtersChanged";
    HEADER_FOOTER_RECALC_TRIGGER["participantChange"] = "ParticipantChange";
    HEADER_FOOTER_RECALC_TRIGGER["headerFooterRendered"] = "pageHeaderOrFooterIsRendered";
    HEADER_FOOTER_RECALC_TRIGGER["privateExportEnvSet"] = "privateExportEnvSet";
})(HEADER_FOOTER_RECALC_TRIGGER = exports.HEADER_FOOTER_RECALC_TRIGGER || (exports.HEADER_FOOTER_RECALC_TRIGGER = {}));
(function (angularModule) {
    angularModule.factory('prHeaderFooterInitService', [
        '$q',
        'prHeaderFooterService',
        'prPageHeaderFooterOptionsService',
        'prPipedTextDynamicValueService',
        'prPageHeaderFooterGenerator',
        'prEventService',
        'pr.WIDGET_MANAGER_EVENTS',
        'rsEnvironment',
        function ($q, headerFooterService, headerFooterOptionsService, DynamicValueService, pageHeaderFooterGenerator, eventService, WIDGET_MANAGER_EVENTS, env) {
            var DEFAULT_QUILL_DELTA = {
                ops: [
                    {
                        insert: '\n'
                    }
                ]
            };
            var HEADER = 'header';
            var FOOTER = 'footer';
            var dynamicValue = new DynamicValueService();
            eventService.on(HEADER_FOOTER_RECALC_TRIGGER.participantChange, recalculatePipedText);
            eventService.on(HEADER_FOOTER_RECALC_TRIGGER.filters, recalculatePipedText);
            eventService.on(HEADER_FOOTER_RECALC_TRIGGER.privateExportEnvSet, recalculatePipedText);
            eventService.on(WIDGET_MANAGER_EVENTS.CUSTOM_METRICS_CHANGED, recalculatePipedText);
            function recalculatePipedText() {
                if (env.get(environment_1.ENV_VARS.FEATURES)[feature_flipper_1.FEATURES.HEADER_FOOTER_PIPED_TEXT]) {
                    var headerFooterLayout = lodash_1.default.clone(headerFooterService.getProperties());
                    setHeaderFooterData(headerFooterLayout, HEADER);
                    setHeaderFooterData(headerFooterLayout, FOOTER);
                    return $q.all([updatePipedTextHeaderFooter(HEADER, headerFooterLayout),
                        updatePipedTextHeaderFooter(FOOTER, headerFooterLayout)]);
                }
                else {
                    return $q.when();
                }
            }
            function updatePipedTextHeaderFooter(headerFooter, headerFooterLayout) {
                var content = headerFooterOptionsService.getContents(headerFooter);
                return dynamicValue.fetchPipedTextValue(content.ops).then(function (newContent) {
                    var newHeaderFooterQuill = lodash_1.default.cloneDeep(DEFAULT_QUILL_DELTA);
                    newHeaderFooterQuill.ops = newContent;
                    headerFooterOptionsService.setContents(headerFooter, newHeaderFooterQuill);
                    var headerFooterData = headerFooterLayout[headerFooter];
                    headerFooterData.quillObject = newHeaderFooterQuill;
                    headerFooterData.html = pageHeaderFooterGenerator.getHeaderFooterHTML(headerFooterData);
                    headerFooterService.updateHeaderOrFooter(headerFooter, headerFooterLayout);
                });
            }
            function setHeaderFooterData(headerFooterLayout, headerFooter) {
                var headerFooterData = headerFooterLayout[headerFooter];
                var headerFooterQuill = headerFooterData.quillObject;
                var defaultQuillDelta = headerFooterOptionsService.getContents(headerFooter);
                if (headerFooterQuill !== defaultQuillDelta) {
                    headerFooterOptionsService.setContents(headerFooter, headerFooterQuill);
                }
            }
            return {
                recalculatePipedText: recalculatePipedText,
                setHeaderFooterData: setHeaderFooterData
            };
        }
    ]);
})(angular_1.default.module('qualtrics.pr'));
